import React from "react";
import { Icon, IconButton } from "@material-ui/core";
import _ from "lodash";

import { FlexLayout } from "js/Components/FlexLayout";
import { TextContent } from "js/Components/TextContent";
import { ShowDialogAsync } from "js/react/components/Dialogs/BaseDialog";

import DocumentTextDialog from "../dialogs/DocumentTextDialog";

export default function TextContextInput(props: { text: string, onTextChange: (text: string | null) => void }) {
    const { text, onTextChange } = props;

    const openDocumentTextDialog = async () => {
        await ShowDialogAsync(DocumentTextDialog, {
            text, onTextChange,
        });
    };

    return (
        <FlexLayout align="center" alignSelf="stretch" border="1px solid #EEE" height={38} width={228} padding="7px 6px 7px 12px" gap={10} clickable>
            <Icon fontSize="small" style={{ color: "#666" }}>create</Icon>
            <FlexLayout noHover width="fill" clickable onClick={openDocumentTextDialog}>
                <TextContent noWrap light>
                    {text ? _.truncate(text, { length: 180 }) : "Type or paste text..."}
                </TextContent>
            </FlexLayout>
            <IconButton size="small" onClick={() => onTextChange(null)}>
                <Icon fontSize="small">close</Icon>
            </IconButton>
        </FlexLayout>
    );
}
